//Constants in customer agent dashboard
export const getPlanDetails = (customerDashboardData) =>
  customerDashboardData?.order_details?.flatMap((order, index) => [
    {
      label: `Optimum plans ${index + 1}`,
      value: order?.plan_data?.name || "-",
    },
    {
      label: `Mobile device ${index + 1}`,
      value: order?.mobile_device_data?.name || "-",
    },
    {
      label: `Add ons ${index + 1}`,
      value: order?.add_on_data?.name || "-",
    },
    {
      label: `Financing options ${index + 1}`,
      value: order?.finance_option_data?.name || "-",
    },
    {
      label: `Number to port ${index + 1}`,
      value:
        order?.current_phone_number == null ||
        order?.current_phone_number === "undefined"
          ? "-"
          : order.current_phone_number,
    },
    {
      label: `IMEI number ${index + 1}`,
      value: order?.imei_number || "-",
    },
  ]) || [];

export const getCustomerDetails = (customerDashboardData) => [
  {
    label: "Business name",
    value: customerDashboardData?.customer_data?.business_name || "-",
  },
  {
    label: "Customer name",
    value: customerDashboardData?.customer_data?.customer_name || "-",
  },
  {
    label: "Contact phone number",
    value: customerDashboardData?.customer_data?.phone_number || "-",
  },
  {
    label: "Customer email address",
    value: customerDashboardData?.customer_data?.email || "-",
  },
  {
    label: "Tax ID",
    value: customerDashboardData?.customer_data?.tax_id || "-",
  },
  {
    label: "Account number (if applicable)",
    value: customerDashboardData?.customer_data?.account_number || "-",
  },
  {
    label: "Zip code",
    value: customerDashboardData?.customer_data?.zipcode || "-",
  },
  {
    label: "Billing address",
    value: customerDashboardData?.customer_data?.billing_address || "-",
  },
];

export const getOrderDetails = (customerDashboardData) => [
  {
    label: "Name",
    value: customerDashboardData?.reseller_agent_info?.name || "-",
  },
  {
    label: "Email",
    value: customerDashboardData?.reseller_agent_info?.email || "-",
  },
  {
    label: "Organization Name",
    value: customerDashboardData?.reseller_agent_info?.organization || "-",
  },
  {
    label: "Z code",
    value: customerDashboardData?.reseller_agent_info?.zcode || "-",
  },
];

export const getCustomerDashboardSections = (
  planDetails,
  customerDetails,
  orderDetails
) => [
  { name: "Optimum Plans", fieldSet: planDetails },
  { name: "Customer Information", fieldSet: customerDetails },
  { name: "Agent Information", fieldSet: orderDetails },
];

export const popupTexts = {
  accept_header: "Are you sure want to complete this plan?",
  accept_subheader: "Are you sure want to complete this plan?",
  reject_header: "Are you sure want to reject this plan?",
  reject_subheader: "Are you sure want to reject this plan?",
  reject_btn: "Reject plan",
  confirm_btn: "Yes, confirm",
  cancel_btn: "No, cancel",
  credentials_cancel: "Cancel",
  credentials_send: "Send",
  credentials_email_header: "Confrim send request",
  credentials_email_subheader:
    "Are you certain you want to share the PIN/Pwd with the customer?",
  warning_header: "This order has been cancelled",
  warning_subheader: "Are you sure you want to continue?",
  warning_confirm_btn: "Yes, continue",
  delete_header: "Are you sure want to delete",
  delete_subheader: "Are you sure want to delete this",
};

export const adminTexts = {
  error_message: "An unexpected error occurred. Please try again later.",
};

export const popupTimeoutDelay = 3000;
